import { ApiBlockItemModel } from '@/services/platform/api/model';
import React, { Suspense } from 'react';

import { SplashContext } from '@/lib/core/types';
import { SplashOnboardingStep1 } from './steps/splashOnboardingStep1';
import { SplashWelcomeScreenStep } from './steps/splashWelcomeScreenStep';
import { SplashOnboardingStep2 } from './steps/splashOnboardingStep2';
import { SplashCreateAccountStep } from './steps/splashCreateAccountStep';
import { SplashPinStep } from './steps/splashPinStep';
import { SplashFaceIdStep } from './steps/splashFaceIdStep';

interface SplashStepProps {
  item: ApiBlockItemModel;
  index: number;
  context?: SplashContext;
  extraProps?: Record<string, any>;
}

const components = [
  { contentType: 'splashOnboardingStep1', component: SplashOnboardingStep1 },
  { contentType: 'splashOnboardingStep2', component: SplashOnboardingStep2 },
  { contentType: 'splashWelcomeScreenStep', component: SplashWelcomeScreenStep },
  { contentType: 'splashCreateAccountStep', component: SplashCreateAccountStep },
  { contentType: 'splashPinStep', component: SplashPinStep },
  { contentType: 'splashFaceIdStep', component: SplashFaceIdStep },
];

export function Step({ item, index, context, extraProps = {} }: SplashStepProps) {
  const matchedComponent = components.find(c => c.contentType === item.content?.contentType);

  if (matchedComponent === undefined) {
    return null;
  }

  const DynamicComponent = matchedComponent.component;

  return (
    <Suspense fallback={null}>
      <DynamicComponent
        index={index}
        content={item.content}
        settings={item.settings}
        context={context}
        {...extraProps}
      />
    </Suspense>
  );
}
